// extracted by mini-css-extract-plugin
export default {"text-field":"EFAutoComplete_text-field__9YdsG","dark":"EFAutoComplete_dark__j6rtq"};